import { category, range } from '../../../packages/configs/layer-builder';

export const layers = [
  {
    header: 'Analysis Layers',
    id: 'analysis-layers',
    layers: [
      range({
        label: 'Total Impact',
        key: 'total_impact',
        forceDots: true,
        unit: 'dollars',
        colorScheme: 'positive-3',
        geom: 'geom2',
      }),
      range({
        label: 'Impact on Nearby Residential Properties',
        key: 'opportunity_impact_res',
        forceDots: true,
        unit: 'dollars',
        colorScheme: 'positive-1',
        geom: 'geom2',
      }),
      range({
        label: 'Impact on Nearby Commercial Properties',
        key: 'opportunity_impact_com',
        forceDots: true,
        unit: 'dollars',
        colorScheme: 'positive-2',
        geom: 'geom2',
      }),
      category({
        label: 'Deal Type',
        key: 'opp_type_combo',
        forceDots: true,
        default: true,
        colorScheme: 'default',
        geom: 'geom2',
      }),
      range({
        label: 'Benefit Cost Ratio',
        key: 'bcr',
        locked: true,
        forceDots: true,
        unit: 'number',
        colorScheme: 'positive-2',
      }),
      range({
        label: 'Predicted Residential Impact at $1m Investment',
        key: 'res_impact_1m_total',
        locked: true,
        source: 'submarkets',
        unit: 'dollars',
        colorScheme: 'positive-2',
      }),
      range({
        label: 'Predicted Commercial Impact at $1m Investment',
        key: 'com_impact_1m_total',
        locked: true,
        source: 'submarkets',
        unit: 'dollars',
        colorScheme: 'positive-3',
      }),
      {
        label: 'Submarket',
        key: 'cluster3',
        locked: true,
        source: 'submarkets',
        unit: 'text_map',
      },
    ],
  },
  {
    header: 'Census Tract Layers',
    id: 'submarket-layers',
    layers: [
      category({
        label: 'Had Intervention(s)',
        key: 'had_intervention',
        source: 'submarkets',
        colorScheme: 'default',
      }),
      range({
        label: 'Median Household Income',
        key: 'med_hh_inc',
        source: 'submarkets',
        unit: 'dollars',
        colorScheme: 'positive-1',
      }),
      range({
        label: 'Median Home Value',
        key: 'med_hom_val',
        source: 'submarkets',
        unit: 'dollars',
        colorScheme: 'positive-2',
      }),
      range({
        label: 'Median Rent',
        key: 'med_rent',
        source: 'submarkets',
        unit: 'dollars',
        colorScheme: 'positive-2',
      }),
      range({
        label: 'Housing Units',
        key: 'hu',
        source: 'submarkets',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Housing Units Occupied',
        key: 'hu_occ',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Housing Units Unoccupied',
        key: 'hu_unocc',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Housing Units Owner Occupied',
        key: 'hu_own_occ',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Employment Density Per Sq. Mile',
        key: 'emp_den',
        source: 'submarkets',
        unit: 'small_decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Employment',
        key: 'emp',
        source: 'submarkets',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Unemployment Percentage',
        key: 'unemp_pct',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Population/Employment Ratio',
        key: 'pop_emp_ratio',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Poverty Percentage',
        key: 'pov_pct',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: "Age 25+ with Bachelor's Degree Percentage",
        key: 'ed_ba_plus',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Population Density',
        key: 'pop_den',
        source: 'submarkets',
        unit: 'small_decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Housing Unit Median Age',
        key: 'hu_med_age',
        source: 'submarkets',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Household With Kids',
        key: 'hh_w_kids',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Average Household Size',
        key: 'hh_size',
        source: 'submarkets',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Median Age',
        key: 'age_median',
        source: 'submarkets',
        colorScheme: 'positive-3',
      }),
      range({
        label: 'Population',
        key: 'pop',
        source: 'submarkets',
        colorScheme: 'positive-3',
      }),

      range({
        label: '% of Population White',
        key: 'rc_white',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
      range({
        label: '% of Population Black or African American',
        key: 'rc_afam',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
      range({
        label: '% of Population American Indian or Alaska Native',
        key: 'rc_natv',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
      range({
        label: '% of Population Asian',
        key: 'rc_asian',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
      range({
        label: '% of Population Native Hawaiian or Other Pacific Islander',
        key: 'rc_islnd',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
      range({
        label: '% of Population Other Race',
        key: 'rc_other',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
      range({
        label: '% of Population Two or More Races',
        key: 'rc_2p',
        source: 'submarkets',
        unit: 'decimal_percent',
        colorScheme: 'positive-2',
        values: [0, 0.025, 0.05, 0.1, 0.2, 0.4],
      }),
    ],
  },
  {
    header: 'Overlays',
    id: 'boundary-layers',
    layers: [
      {
        label: 'Road Labels',
        key: 'road_label_layer',
        url:
          'https://stamen-tiles-a.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}@2x.png',
        style: {
          type: 'raster',
        },
      },
      {
        label: 'Roads',
        key: 'road_layer',
        url:
          'https://stamen-tiles.a.ssl.fastly.net/toner-lines/{z}/{x}/{y}@2x.png',
        style: {
          type: 'raster',
        },
      },
      {
        label: 'Parcel Boundaries',
        key: 'opp_name',
        style: {
          type: 'line',
          paint: {
            'line-color': '#4b4c4d',
            'line-width': 2,
          },
        },
      },
      {
        label: 'Counties',
        key: 'id',
        source: 'mi_counties',
        default: true,
        style: {
          type: 'line',
          paint: {
            'line-color': '#4b4c4d',
            'line-width': 1,
          },
        },
      },
      {
        label: '6 Study Cities',
        key: 'id+cities',
        source: 'city_boundaries',
        default: true,
        style: {
          type: 'line',
          paint: {
            'line-color': '#1f78b4',
            'line-width': 2,
          },
        },
      },
    ],
  },
];
